import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { StatistikService } from '../../statistik.service';
import { StatistikTidsforbrugPlantid } from '../../models/StatistikTidsforbrugPlantidViewModel';

@Component({
    selector: 'app-statistik-plantid-modal-ui',
    templateUrl: './statistik-plantid-modal.component.html',
    styleUrls: ['./statistik-plantid-modal.component.scss'],
    standalone: false
})
export class StatistikPlantidModalComponent implements OnInit {
    medid: number;
    medarbejderName: string;
    selectedPeriod: { fra: string, til: string };
    totalHours = 0;

    TidsforbrugPlantidViewList$: Observable<StatistikTidsforbrugPlantid[]>;

    constructor(private activeModal: NgbActiveModal,
                private statistikService: StatistikService) {
    }

    ngOnInit(): void {
        this.TidsforbrugPlantidViewList$ = this.statistikService.getPlantidModalView(this.medid, this.selectedPeriod);
        this.getTotalHours();
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    getTotalHours() {
        this.TidsforbrugPlantidViewList$.subscribe((tidsforbrugPlantidList) => {
            this.totalHours = tidsforbrugPlantidList.reduce((total, tidsforbrugPlantid) => total + tidsforbrugPlantid.timer, 0);
        });
    }
}







